import React, { Suspense } from 'react'
import { LoadingComponent } from '../loading/index'

const ReactSelect = React.lazy(() => import('react-select'))

const AsyncReactSelect = React.forwardRef((props, ref) => (
  <Suspense fallback={<LoadingComponent />}>
    <ReactSelect ref={ref} {...props} />
  </Suspense>
))

AsyncReactSelect.displayName = 'AsyncReactSelect'

export default AsyncReactSelect
